/* @flow */
import * as React from 'react';
import API from 'lib/RemindAPI';
import Chat from 'entities/Chat';
import invariant from 'invariant';
import Glyph from 'components/Glyph';
import Button from 'components/ButtonDeprecated';
import { showToast, showAPIErrorToast } from 'reducers/toasts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import jstz from 'jstimezonedetect';
import { withPhoneCallPermissions } from 'phoneCalls/lib/permissions';

type Props = {
  chat: Chat,
  buttonClassName?: string,
  showToast: (text: string, kind: 'success' | 'error') => void,
  showAPIErrorToast: (error: *) => void,
  canMakePhoneCalls: boolean,
};

class EmailPhoneCallHistoryButton extends React.Component<Props> {
  sendEmail = () =>
    (async () => {
      const timeZone = jstz.determine().name();
      const otherMember = this.props.chat.getOtherMember();

      invariant(otherMember, 'cannot send email with null other member');
      invariant(otherMember.uuid, 'cannot send email with other member null uuid');

      try {
        await API.request('/phone_calls/email_call_log', 'POST', {
          other_user_uuid: otherMember.uuid,
          time_zone: timeZone,
        });

        this.props.showToast(
          'We’ve sent the phone call history of this conversation to your email address.',
          'success'
        );
      } catch (e) {
        this.props.showAPIErrorToast(e);
        console.debug(e, e && e.stack);
      }
    })();

  render() {
    if (!this.props.canMakePhoneCalls) {
      return null;
    }

    if (!this.props.chat.isIndividualType()) {
      return null;
    }

    return (
      <div className="EmailPhoneCallHistoryButton">
        <Button
          level="text"
          weight="semibold"
          onClick={this.sendEmail}
          className={this.props.buttonClassName}>
          <Glyph name="call-transcript" size="large" />
          <span>Email call history</span>
        </Button>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowIssue
  return bindActionCreators({ showToast, showAPIErrorToast }, dispatch);
}

export { EmailPhoneCallHistoryButton };
export default compose(
  withPhoneCallPermissions,
  connect(undefined, mapDispatchToProps)
)(EmailPhoneCallHistoryButton);
